import PropTypes from "prop-types";
import { Modal, Typography } from "antd";
import CustomIcon from "./layouts/CustomIcon";
import { isMobile, isDesktop } from "react-device-detect";
import { createContext, useContext, useMemo } from "react";

const { Title, Paragraph } = Typography;

// DesktopContext to keep the latest state
const DesktopContext = createContext(null);

// useDesktopContext to share this components state everywhere this component is imported
export const useDesktopContext = () => {
  const context = useContext(DesktopContext);

  if (!context) throw new Error("useDesktopContext context must be use inside DesktopProvider");

  return context;
};

DesktopProvider.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string,
};

export default function DesktopProvider({ children, title = "", message = "" }) {
  // Pass the state to the context
  const memoizedValue = useMemo(() => ({ isMobile, isDesktop }), []);

  return (
    <DesktopContext.Provider value={memoizedValue}>
      {/* If the user is on mobile, show a modal */}
      {isMobile && (
        <Modal centered open={true} width='90%' footer={null}>
          <Title className='fw-600 m-0' level={3}>
            {title || "Report available on Computer only"}
          </Title>

          <div className='text-center p-3'>
            <CustomIcon name='desktop2' />
          </div>

          <Paragraph className='font-size-16px'>
            {message ||
              "This experience is only available on a Computer screen. Please open the link using computer and Chrome browser."}
          </Paragraph>
        </Modal>
      )}

      {/* If the user is on desktop, show the children */}
      {isDesktop && children}
    </DesktopContext.Provider>
  );
}
